import { colors } from "../../Styles";

export function Minimize({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      {/* <g transform="matrix(-0.5042,0.5042,-0.5042,-0.5042,364.529,54.894)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(0.5042,-0.5042,0.5042,0.5042,-81.0687,228.566)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(0.5042,0.5042,-0.5042,0.5042,54.894,-81.0687)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(-0.5042,-0.5042,0.5042,-0.5042,228.566,364.529)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g> */}
      <g transform="matrix(-0.5042,0.5042,-0.5042,-0.5042,374.529,44.894)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.83L93.623,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(0.5042,-0.5042,0.5042,0.5042,-91.0687,238.566)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.83L93.623,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(0.5042,0.5042,-0.5042,0.5042,44.894,-91.0687)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.83L93.623,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(-0.5042,-0.5042,0.5042,-0.5042,238.566,374.529)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.83L93.623,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
    </svg>
  );
}